// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__1Y31Z","content":"Modal_content__9u3+I"};